import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box id="contactme" sx={{
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '3rem 1rem 2rem'
        }}>
            <Box sx={{
                marginBottom: '2rem',
                width: '100%',
                maxWidth: '800px',
                display: 'flex',
                flexDirection: {xs: 'column', md: 'row'},
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '2rem'
            }}>
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: {xs: 'center', md: 'flex-start'}}}>
                    <Typography variant="h3" sx={{
                        color: '#ffffff',
                        fontWeight: 700,
                        marginBottom: '0.5rem',
                        fontSize: '1.75rem'
                    }}>Let's Connect</Typography>
                    <Typography variant="body" sx={{color: '#94a3b8', maxWidth: '400px'}}>
                        I'm always open to discussing new opportunities, creative ideas, or just having a chat about technology.
                    </Typography>
                </Box>
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: {xs: 'center', md: 'flex-end'}}}>
                    <Button
                        variant="contained"
                        href="mailto:lucaliu96@gmail.com?Subject=Portfolio Inquiry"
                        sx={{
                            backgroundColor: '#3b82f6',
                            color: 'white',
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            marginBottom: '0.75rem',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                            '&:hover': {
                                backgroundColor: '#60a5fa',
                                boxShadow: '0 6px 16px rgba(59, 130, 246, 0.4)',
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        Send Email
                    </Button>
                    <Typography variant="note" sx={{color: '#94a3b8'}}>lucaliu96@gmail.com</Typography>
                </Box>
            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '1rem',
                marginBottom: '2rem'
            }}>
                <IconButton
                    component="a"
                    href="https://github.com/liulc006"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        width: '48px',
                        height: '48px',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        color: '#ffffff',
                        borderRadius: '12px',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: '#3b82f6',
                            color: '#ffffff',
                            transform: 'translateY(-3px)',
                            boxShadow: '0 8px 20px rgba(59, 130, 246, 0.4)'
                        }
                    }}
                >
                    <GitHubIcon />
                </IconButton>
                <IconButton
                    component="a"
                    href="https://www.linkedin.com/in/luca-liu/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        width: '48px',
                        height: '48px',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        color: '#ffffff',
                        borderRadius: '12px',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: '#0077b5',
                            color: '#ffffff',
                            transform: 'translateY(-3px)',
                            boxShadow: '0 8px 20px rgba(0, 119, 181, 0.4)'
                        }
                    }}
                >
                    <LinkedInIcon />
                </IconButton>
                <IconButton
                    component="a"
                    href="mailto:lucaliu96@gmail.com?Subject=Portfolio Inquiry"
                    rel="noopener noreferrer"
                    sx={{
                        width: '48px',
                        height: '48px',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        color: '#ffffff',
                        borderRadius: '12px',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: '#3b82f6',
                            color: '#ffffff',
                            transform: 'translateY(-3px)',
                            boxShadow: '0 8px 20px rgba(59, 130, 246, 0.4)'
                        }
                    }}
                >
                    <EmailIcon />
                </IconButton>
            </Box>

            <Box sx={{
                borderTop: '1px solid rgba(255,255,255,0.1)',
                width: '100%',
                maxWidth: '800px',
                paddingTop: '1.5rem',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.5rem'
            }}>
                <Typography variant="note" sx={{color: '#64748b'}}>
                    Design and developed by Luca Liu
                </Typography>
                <Typography variant="note" sx={{color: '#64748b'}}>© 2023 - {currentYear} Luca Liu</Typography>
            </Box>
        </Box>
    );
};

export default Footer;
